<template>
    <div class="save-tips-container" :class="[show ? 'show animate__animated animate__fadeInDown': '']">
        <div class="save-tips-content">
            <div>如要把应用程序加至主屏幕</div>
            <div>
                请点击<img class="save-tips_share-icon" src="@/assets/share-icon.jpg">，然后 <b>添加到主屏幕</b>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SaveDesktopTips',
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped lang="scss">
.save-tips-container {
    padding: 16px;
    box-sizing: border-box;
    background-color: $white;
    border-radius: 8px;
    position: fixed;
    width: max-content;
    max-width: 300px;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 16px;
    font-size: 14px;
    display: none;
}

.save-tips-container.show {
    display: block;
}

.save-tips-content {
    text-align: center;
    line-height: 1.47;
    position: relative;
}

.save-tips-content:after {
    content: '';
    width: 24px;
    height: 24px;
    background-color: $white;
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    right: 0;
    margin: auto;
    transform: rotate(45deg);
}

.save-tips_share-icon {
    display: inline-block;
    vertical-align: text-bottom;
    height: 24px;
    margin: 0 4px;
}
</style>
